import Messages from '../locales/en.json'
import i18n from '../i18n'

export const maocData = {
  vesselTypes: [
    'vessel',
    'aeroplane',
    'other'
  ],
  requestTypes: [
    'registration',
    'coregistration',
    'update',
    'upgrade',
    'downgrade',
    'reactivation',
    'removal'
  ],
  categories: [
    'category_1',
    'category_2',
    'rfi'
  ],
  countries: [
    'belgium',
    'france',
    'germany',
    'ireland',
    'italy',
    'netherlands',
    'portugal',
    'spain',
    'united_kingdom',
    'united_states',
  ],
  controlType: [
    'ais_similar',
    'technical_permanent_control',
    'surveillance'
  ],
  agencies: {
    belgium: ['Customs', 'Federal Police', 'Local Police'],
    france: ['DNRED', 'GEND', 'Navy', 'OFAST'],
    germany: ['BKA' ],
    ireland: ['GARDA', 'Navy', 'CUSTAIM'],
    italy: ['GF', 'CARAB'],
    netherlands: ['Customs', 'NP'],
    portugal: ['PJ', 'Navy', 'Airforce', 'Maritime Police'],
    spain: ['CNP', 'GC', 'DAVA'],
    united_kingdom: ['NCA'],
    united_states: ['DEA', 'JIATF-S']
  },
  ownerTypes: [
    'person',
    'company'
  ],
  sourceEvaluation: [
    'A',
    'B',
    'C',
    'D'
  ],
  intelEvaluation: [
    '1',
    '2',
    '3',
    '4'
  ],
  informationOptions: [
    'profiling',
    'intelligence'
  ],
  dynamicLocalizedSelect: function (translationTag) {
    const dict = Object.keys(Messages[translationTag]).sort()
    return this.__asLocalizedSelect(dict, translationTag)
  },
  asLocalizedSelect: function (data, translationTag = '') {
    return this.__asLocalizedSelect(this[data], translationTag)
  },
  asSortedLocalizedSelect: function (data, translationTag = '') {
    return this.__asLocalizedSelect(this[data].sort(), translationTag).sort((a, b) => i18n.t(a.text).localeCompare(i18n.t(b.text)))
  },
  __asLocalizedSelect: function (data, key) {
    var localized = []
    if (key) {
      key = key + '.'
    }
    for (const d in data) {
      localized.push({
        text: key + data[d],
        value: data[d]
      })
    }
    return localized
  }
}
